module.exports = __webpack_public_path__ + "static/media/phone.58d7e3d6.svg";